<template>
  <q-pull-to-refresh @refresh="loadUsers">
    <q-card flat>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions>
          مدیریت کاربران
          <template v-slot:action>
            <q-btn icon="phone" flat round @click="refreshMobileNo">
              <q-tooltip>
                به روزرسانی شماره های موبایل بانک از طریق سرویس احراز هویت
              </q-tooltip>
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-input v-model="filter" filled label="جستجو..."/>
        <q-table
            selection="single"
            :data="items"
            row-key="id"
            wrap-cells
            :hide-header="$q.screen.lt.md"
            flat
            :filter="filter"
            :rows-per-page-options=[100]>
          <template v-slot:header>
            <q-tr class="text-center text-bold">
              <td></td>
              <td>نام کاربری</td>
              <td>نام</td>
              <td>نام خانوادگی</td>
              <td>شماره تماس</td>
              <td>تاریخ ثبت</td>
              <td>آخرین ورود</td>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props" class="text-center">
              <td style="width: 100px">
                <q-icon name="lock"
                        style="cursor: pointer"
                        :color="props.row.active?'green':'red'"
                        size="md"
                        @click="changeActiveState(props.row)"/>
                <q-btn round flat color="purple" icon="edit" padding="none"
                       @click="showDetails(props.row)">
                  <q-tooltip>
                    ویرایش اطلاعات
                  </q-tooltip>
                </q-btn>
              </td>
              <td style="width: 150px">
                <span style="direction: ltr">{{ props.row.username }}</span>
              </td>
              <td v-if="$q.screen.lt.md">{{ props.row.fullName }}</td>
              <td v-if="!$q.screen.lt.md">{{ props.row.firstName }}</td>
              <td v-if="!$q.screen.lt.md">{{ props.row.lastName }}</td>
              <td style="direction: ltr" v-if="!$q.screen.lt.md">{{ props.row.mobilePhone }}</td>
              <td style="direction: ltr" v-if="!$q.screen.lt.md">{{ props.row.insertInstant | toJalaliDateTime }}</td>
              <td style="direction: ltr" v-if="!$q.screen.lt.md">{{
                  props.row.lastLoginInstant | toJalaliDateTime
                }}
              </td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-dialog maximized v-model="userDetailDialog" persistent>
      <User :item="selectedItem" @user-updated="userUpdated" @shaba-verified="verifiedShaba"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from "vuex";
import User from "@/components/Users/User";

export default {
  name: "UsersList",
  components: {User},
  props: {},
  data() {
    return {
      filter: '',
      items: [],
      selectedItem: undefined,
      userDetailDialog: false,
      storeList: []
    }
  },
  methods: {
    ...mapActions({
      usersList: 'Users/getUsersManagementList',
      deactiveUser: 'Users/deactiveUser',
      activeUser: 'Users/activeUser',
      refreshMobile:'Users/syncMobileNo'
    }),
    refreshMobileNo(){
      this.refreshMobile().then(()=>{
        this.initializeList();
        this.$q.notify({
          message:'به روز رسانی شماره های موبایل به پایان رسید',
          type:'positive',
          position:'center'
        })
      })
    },
    verifiedShaba(args) {
      const index = this.items.findIndex(item => {
        return (item.Users_ID === args.Users_ID)
      })
      this.items[index].ShabaVerify = true
    },
    userUpdated(args) {
      const index = this.items.findIndex(item => {
        return (args.Users_ID === item.Users_ID)
      })
      this.items.splice(index, 1, args)
      this.userDetailDialog = false
    },
    showActionsButton(row) {
      if (row.active) {
        this.selectedItem = row;
        const actionRow = document.getElementById(`actionRow-${row.id}`)
        actionRow.style.display = 'block'
      }
    },
    hideActionsButton(row) {
      this.selectedItem = row;
      const actionRow = document.getElementById(`actionRow-${row.id}`)
      actionRow.style.display = 'none'
    },
    showDetails(row) {
      this.selectedItem = row
      this.userDetailDialog = true
    },
    changeActiveState(row) {
      this.selectedItem = row;
      if (this.selectedItem.active) {
        this.deactiveUser(row.id).then(() => {
          row.active = false;
        })
      } else {
        this.activeUser(row.id).then(() => {
          row.active = true;
        })
      }
    },
    loadUsers(done) {
      this.usersList().then((res) => {
        this.items = res
        done()
      })
    },
    initializeList() {
      this.usersList().then((res) => {
        this.items = res
      })
    }
  },
  created() {
    this.initializeList();
  }
}
</script>

<style scoped>

</style>